import './gradient.css'
import { createApp, defineAsyncComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import VueParticles from '@tsparticles/vue3'
import { loadSlim } from '@tsparticles/slim'

new BlockModule({
    selector: '.block-background-particles',
    setupBlock(el, onTeardown) {
        console.log(el)
        const vueApp = createApp(
            defineAsyncComponent(() => import('./components/BackgroundParticles.vue')),
        ).use(VueParticles, {
            init: async (engine) => {
                await loadSlim(engine)
            },
        })

        vueApp.mount(el)

        onTeardown(() => {
            vueApp.unmount()
        })
    },
})
